/* eslint-disable indent,radix */
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { change, formValueSelector } from 'redux-form'
import Dropzone from 'react-dropzone'
import Modalhandler from 'components/shared/modal/modal-handler'
import * as uploadTypes from 'actions/uploader/types'
import DeleteIcon from './DeleteIcon'
import EditIcon from './EditIcon'
import ImageEditor from './image-editor'

const UploaderPreviewField = ({
  groupClassName,
  label,
  labelClassName,
  acceptedFiles = 'image/gif, image/jpeg, image/png',
  multipleUpload,
  form,
  dispatch,
  venueImages = [],
  name = 'images',
  resize = false,
  maxUpload = 7,
  images,
  emptyInit,
}) => {
  const dropZone = useRef()
  const [processing, setProcessing] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState([])
  const initAction = { action: 'add', multiple: true }
  const [uploadAction, setUploadAction] = useState(initAction)
  const [imageEditorVisibility, setImageEditorVisibility] = useState(false)
  const [imageEditorSrc, setImageEditorSrc] = useState()
  const [imageEditor, setImageEditor] = useState()
  const [indexImageEditor, setIndexImageEditor] = useState()

  useEffect(() => {
    if (emptyInit) {
      return
    }
    if (venueImages && venueImages.length) {
      setUploadedFiles(venueImages)
    }
  }, [venueImages, emptyInit])

  useEffect(() => {
    dispatch(change(form, name, uploadedFiles))
  }, [uploadedFiles])

  useEffect(() => {
    if (emptyInit) {
      return
    }
    if (images) {
      setUploadedFiles(images)
    }
  }, [images, emptyInit])

  const handleFileChange = async (files) => {
    const action = uploadAction.action
    const max = action === 'edit' ? 1 : maxUpload - uploadedFiles.length
    setProcessing(true)
    const results = await multipleUpload({ files, max, resize })
    const images = results.map((result) => {
      return {
        path: result.path,
        image: result.name,
        order: action === 'add' ? result.index + uploadedFiles.length + 1 : uploadAction.index + 1,
      }
    })
    if (action === 'add') {
      setUploadedFiles([...uploadedFiles, ...images])
    } else {
      uploadedFiles[uploadAction.index] = images[0]
      setUploadedFiles([...uploadedFiles])
    }
    setProcessing(false)
    setUploadAction(initAction)
  }

  const onDragStart = (e, index) => {
    e.dataTransfer.setData('index', index)
  }

  const onDrop = (e, index) => {
    const fromIndex = e.dataTransfer.getData('index')
    const toIndex = index
    let newImages = uploadedFiles
    const imageFrom = newImages[fromIndex]
    const imageTo = newImages[toIndex]
    imageFrom.order = parseInt(toIndex) + 1
    imageTo.order = parseInt(fromIndex) + 1
    newImages = newImages.sort((i1, i2) => (i1.order > i2.order ? 1 : -1))
    setUploadedFiles([...newImages])
  }

  const onViewerImage = (index) => {
    const image = uploadedFiles[index]

    if (image) {
      setImageEditorSrc(`${image.path}?o=true`)
      setImageEditor(image)
      setImageEditorVisibility(true)
      setIndexImageEditor(index)
    }
  }

  const updateImageEdited = (index, imgObj) => {
    const newImages = uploadedFiles
    newImages[index] = imgObj
    setUploadedFiles([...newImages])
  }

  const deleteByIndex = (index) => {
    uploadedFiles.splice(index, 1)
    const newImages = uploadedFiles.map((img, i) => ({ ...img, order: i + 1 }))
    setUploadedFiles([...newImages])
  }

  // eslint-disable-next-line no-unused-vars
  const editByIndex = (index) => {
    setUploadAction({ action: 'edit', multiple: false, index })
  }

  useEffect(() => {
    if (uploadAction.index || uploadAction.index === 0) dropZone.current.open()
  }, [uploadAction.index])

  const renderThumbnails = (
    <div className="flex w-full h-auto">
      {uploadedFiles[0] && (
        <div className="w-2/5 h-full">
          <div
            className="w-full relative"
            onDragStart={(e) => onDragStart(e, 0)}
            onDrop={(e) => onDrop(e, 0)}
          >
            <img
              onClick={() => onViewerImage(0)}
              className="w-full h-auto"
              src={`${uploadedFiles[0].path}`}
              alt={uploadedFiles[0].image}
            />
            <div className="absolute w-full inset-x-0 top-0 flex">
              <div className="w-1/5">
                <div className="w-6 h-6 rounded-full bg-white m-2 flex items-center justify-center">
                  {uploadedFiles[0].order || 1}
                </div>
              </div>
              <div className="m-2 text-white w-4/5 flex justify-end">
                <DeleteIcon
                  className="cursor-pointer"
                  aria-hidden="true"
                  onClick={() => deleteByIndex(0)}
                />
                <EditIcon
                  className="cursor-pointer ml-2"
                  aria-hidden="true"
                  onClick={() => onViewerImage(0)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="w-3/5 h-full flex flex-wrap">
        {uploadedFiles.map(
          (image, index) =>
            index > 0 && (
              <div
                className="w-1/3 px-2 py-1"
                key={index}
                onDragStart={(e) => onDragStart(e, index)}
                onDrop={(e) => onDrop(e, index)}
              >
                <div className="w-full relative">
                  <img
                    className="w-full h-auto"
                    onClick={() => onViewerImage(index)}
                    src={image.path}
                    alt={image.image}
                  />
                  <div className="absolute w-full inset-x-0 top-0 flex">
                    <div className="w-1/5">
                      <div className="w-6 h-6 rounded-full bg-white m-2 flex items-center justify-center">
                        {image.order || index + 1}
                      </div>
                    </div>
                    <div className="m-2 text-white w-4/5 flex justify-end">
                      <DeleteIcon
                        className="cursor-pointer"
                        aria-hidden="true"
                        onClick={() => deleteByIndex(index)}
                      />
                      <EditIcon
                        className="cursor-pointer ml-2"
                        aria-hidden="true"
                        onClick={() => onViewerImage(index)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  )

  const showHideEditor = () => {
    setImageEditorVisibility(!imageEditorVisibility)
  }

  return (
    <div className={`flex flex-col ${groupClassName}`}>
      {label && <label className={labelClassName}>{label}</label>}
      <Dropzone
        ref={dropZone}
        accept={acceptedFiles}
        disabled={processing}
        onDrop={(files) => {
          handleFileChange(files)
        }}
        multiple={uploadAction.multiple}
        onFileDialogCancel={() => setUploadAction(initAction)}
      >
        {({ getRootProps, getInputProps, isDragReject }) => (
          <section className="flex">
            <div className="flex flex-row h-full flex-wrap w-4/5">{renderThumbnails}</div>
            <div
              className=" w-1/5 h-1/2 flex justify-center border-dashed border-4 border-secondary-lightgray border-lg py-2 text-center cursor-pointer"
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              {isDragReject && (
                <div className="text-action-danger pointer-events-none">
                  <i className="fa fa-3x fa-ban" aria-hidden="true"></i>
                  <p>{`The file format doesn't seem to be allowed.`}</p>
                </div>
              )}
              {!isDragReject && !processing && (
                <div className="text-primary-lightgray pointer-events-none ">
                  <p className="text-orange-300">Add file</p>
                  <p>{`or drop files to upload`}</p>
                </div>
              )}
              {processing && (
                <div>
                  <i className="fa fa-spinner fa-spin fa fa-spinner fa-spin text-primary-lightgray text-5xl" />
                </div>
              )}
            </div>
          </section>
        )}
      </Dropzone>
      <span className="m-6 right-0 top-0 absolute">
        <Modalhandler
          className="btn rounded font-normal lato px-5 py-3 bg-secondary-lightgray text-primary-black cursor-pointer"
          isOpen={imageEditorVisibility}
          hideButton={true}
        >
          {() => (
            <ImageEditor
              image={imageEditorSrc}
              imageEditorObj={imageEditor}
              showHideEditor={showHideEditor}
              updateImageEdited={updateImageEdited}
              index={indexImageEditor}
            />
          )}
        </Modalhandler>
      </span>
    </div>
  )
}

UploaderPreviewField.propTypes = {
  acceptedFiles: PropTypes.string,
  groupClassName: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  multipleUpload: PropTypes.func.isRequired,
  form: PropTypes.string,
  dispatch: PropTypes.func,
  venueImages: PropTypes.array,
  name: PropTypes.string,
  resize: PropTypes.bool,
  maxUpload: PropTypes.number,
  images: PropTypes.array,
  emptyInit: PropTypes.boolean,
}

const mapStateToProps = ({ merchant, space, auth, ...state }, { form, name }) => {
  const selector = formValueSelector(form)
  return {
    venueImages: selector(state, name),
    images: space.spaceDetails.images,
  }
}

const mapDispatchToProps = (dispatch) => ({
  multipleUpload: (payload) =>
    new Promise((resolve, reject) => {
      dispatch({ type: uploadTypes.MULTIPLE_UPLOAD, payload, resolve, reject })
    }),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(UploaderPreviewField)
